import { PageContainer, PageContentView } from 'components/shared';
import React from 'react';
import AppsAwaitingAuthWidget from './components/AppsAwaitingAuthWidget';
import AuthorizedAppsWidget from './components/AuthorizedAppsWidget';
import "./styles.css";
import "./mobile.css";



/**
 * @function AuthorizedAppsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AuthorizedAppsPage
 */
export default function AuthorizedAppsPage(props) {
  return (
    <PageContainer className="authorized-apps-page">
        <PageContentView>
          <div className="flex-container flex-vertical page-widget-wrapper">
            <AuthorizedAppsWidget />
            <AppsAwaitingAuthWidget />
          </div>
        </PageContentView>
    </PageContainer>
  )
}
